import { createContext, useCallback, useContext, useState } from "react";
import type {
  PayloadActionRow,
  PayloadCheckboxesActionsContextType,
} from "./PayloadCheckboxesActionsContextType";

const PayloadCheckboxesActionsContext = createContext<
  PayloadCheckboxesActionsContextType | undefined
>(undefined);

export const usePayloadCheckboxesActionsContext = () => {
  const context = useContext(PayloadCheckboxesActionsContext);

  if (!context)
    throw new Error(
      "usePayloadCheckboxesActionsContext must be used inside usePayloadCheckboxesActionsProvider",
    );
  return context;
};

export const PayloadCheckboxesActionsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [selectedParentCheckboxKeys, setSelectedParentCheckboxKeys] = useState<
    React.Key[]
  >([]);
  const [selectedChildCheckboxKeys, setSelectedChildCheckboxKeys] = useState<
    React.Key[]
  >([]);
  const [dataRowForActions, setDataRowForActions] = useState<
    PayloadActionRow[]
  >([]);
  const [pendingBtn, setPendingBtn] = useState<unknown>(null);

  const resetPayloadSelection = useCallback(() => {
    setSelectedParentCheckboxKeys([]);
    setSelectedChildCheckboxKeys([]);
    setDataRowForActions([]);
  }, []);

  return (
    <PayloadCheckboxesActionsContext.Provider
      value={{
        selectedParentCheckboxKeys,
        setSelectedParentCheckboxKeys,
        selectedChildCheckboxKeys,
        setSelectedChildCheckboxKeys,
        dataRowForActions,
        setDataRowForActions,
        resetPayloadSelection,
        pendingBtn,
        setPendingBtn,
      }}
    >
      {children}
    </PayloadCheckboxesActionsContext.Provider>
  );
};
